export enum ApprovalState {
  none = "None",
  pending = "Pending",
  approved = "Approved",
  rejected = "Rejected",
  cancelled = "Cancelled",
  returned = "Returned",
  skipped = "Skipped"
}
